import script from "./ProcessPath.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessPath.vue?vue&type=script&setup=true&lang=js"

import "./ProcessPath.vue?vue&type=style&index=0&id=f5b7c772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b7c772"]])

export default __exports__